<template>
  <div class="product-resourse-wrap">
    <h3 class="titleName">{{ $route.query.name }}</h3>
    <div class="btnTop">
      <Button v-if="edit" type="primary" @click="addForm" style="margin-right:20px;">新增</Button>
      <Button v-if="formArr.length" type="primary" @click="downLoad" style="margin-right:20px;">下载全部文档</Button>
    </div>
    <Form :model="item" style="padding-top:30px" :label-width="100" class="formBox" :ref="`form${index}`"
      v-for="(item, index) in formArr" :key="index">
      <div v-if="edit" class="closeBtn" @click="delMaterial(index)">
        <Icon type="ios-close-circle-outline" size="24" />
      </div>
      <Row>
        <Col span="6">
        <FormItem label="类型" prop="categoryId" :rules="typeRule">
          <Select :disabled="!edit" v-model="item.categoryId" :transfer="true">
            <Option :value="item.value" v-for="item in typeList" :key="item.id">{{ item.txt }}</Option>
          </Select>
        </FormItem>
        </Col>
        <Col span="4" style="width:210px">
        <FormItem label="顺序" prop="orderNum" :rules="typeRuleOrder">
          <Input :disabled="!edit" v-model="item.orderNum" :type="edit?'number':'text'"></Input>
        </FormItem>
        </Col>
        <Col span="2">
        <div v-if="edit" class="btn" @click="addPdfList(index)" style="margin-top:6px;margin-left:14px">新增文档</div>
        </Col>
      </Row>
      <Row>
        <Col span="6">
        <FormItem label="显示名称" v-for="(item, index) in item.items" :key="index"
          :rules="{ required: true, message: '名称不能为空', trigger: 'blur' }" :prop="'items.' + index + '.name'">
          <Input :disabled="!edit" v-model="item.name" @on-blur="(event) => { changeItem(event, item) }"></Input>
        </FormItem>
        </Col>
        <Col span="16">
        <FormItem label="文档链接" v-for="(item, idx) in item.items" :key="idx" style="height:34px"
          :rules="{ required: true, message: '文档链接不能为空' }" :prop="'items.' + idx + '.url'" class="clearfix">
          <Upload v-model="item.transUrl" :isDel="edit" style="float:left;margin-right:20px;" action="/" v-if="!item.transUrl"
            :before-upload="(file) => handleBeforeUpload(file, item, index, idx)">
            <Button icon="ios-cloud-upload-outline">点击上传</Button>
          </Upload>
          <a v-else style="float:left;margin-right:10px;" :href="item.transUrl" target="_blank">{{ item.transUrl }}</a>
          <div>
            <div v-if="edit" class="btn" @click="removeList(index, idx)">删除</div>
          </div>
        </FormItem>
        </Col>
      </Row>
    </Form>
    <no-data v-if="formArr.length == 0"></no-data>
    <div class="btnBox" v-if="formArr.length > 0 && edit">
      <Button type="primary" @click="saveForm">保存</Button>
    </div>
  </div>
</template>

<script>
import { common } from "@/api/mixins";
import myForm from "@/components/commons/form";
import upLoad from "@/components/commons/upload";
import upLoadNew from "@/components/commons/uploadNew";
import {
  productManageGetAllType,
  uploadFile,
} from "@/api/httpList";
export default {
  components: {
    upLoad,
    myForm,
    upLoadNew
  },
  mixins: [common],
  props: {
    productForm: {
      type: Object
    },
    edit: {
      type: Boolean,
      default: true,
      required: false
    },
  },
  watch: {
    'productForm.id': {
      handler(newVal) {
        if (newVal) {
          this.queryMaterials();
        }
      },
      immediate: true,
      deep: true
    },
  },
  data() {
    return {
      typeRule: {},
      typeRuleOrder: {},
      typeList: [], //资料列表
      //资料表单
      formArr: [
        {
          categoryId: "",
          orderNum: "",
          items: [
            {
              name: "",
              url: "",
              transUrl: ''
            }
          ]
        }
      ],
      urlDownData:[]
    };
  },
  methods: {
    downLoad(){
      this.urlDownData = []
      this.formArr.forEach(item => (
        item.items.forEach((i)=>{
          this.urlDownData.push(i)
        })
     ));
      this.$units.downloadFile(`/buz/productMaterial/${this.productForm.productCode}/downloadAll`, {list:this.urlDownData}, 'POST');
    },
    delMaterial(index) {
      this.formArr.splice(index, 1)
      this.saveForm()
    },
    //获取产品资料
    async queryMaterials() {
      const res = await this.$http({
        url: "/buz/cms/productMaterial/queryMaterials",
        type: "GET",
        data: {
          productCode: this.productForm.productCode,
        }
      })
      if (res.data.length > 0) {
        //回填数据
        let urlList = [];
        res.data.forEach(item => ({
          items: item.items.forEach(i => {
            if (i.url) {
              urlList.push(i.url)
            }
          }),
        }));
        res.data.map(item=>{
          if(!this.edit){
            item.orderNum=item.orderNum?item.orderNum:'-'
          }
        })
        this.formArr = res.data.map(item => ({
          categoryId: item.typeCode,
          orderNum: item.orderNum,
          items: item.items.map(i => {
            if (i.url) {
              i.transUrl = urlList.shift()
            }
            return i;
          }),
          id: item.id
        }));
      } else {
        this.formArr = [];
      }
    },
    initRule() {
      this.typeRule = {
        validator: this.validatetype,
        trigger: "change",
        required: true
      };
      this.typeRuleOrder = {
        validator: this.validateOrder,
        trigger: "blur",
        required: true
      };
    },
    //验证id类型
    validatetype(rule, value, callback) {
      if (value) {
        //判断value是否重复
        const findRepeatList = this.formArr.filter(
          item => item.categoryId == value
        );
        if (findRepeatList.length > 1) {
          callback(new Error("类型不能重复"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请选择类型"));
      }
    },
    validateOrder(rule, value, callback) {
      if (value) {
        //判断value是否重复
        const findRepeatList = this.formArr.filter(
          item => item.orderNum == value
        );
        if (findRepeatList.length > 1) {
          callback(new Error("顺序不能重复"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入顺序"));
      }
    },
    async saveForm() {
      console.log(this.formArr);
      //判断categoryId是否重复
      let num = 0;
      this.formArr.forEach((item, index) => {
        this.$refs["form" + index][0].validate(valid => {
          if (valid) {
            num++;
          }
        });
      });
      if (num === this.formArr.length) {
        // this.$Message.success("验证成功");
        const obj = this.formArr.map(item => {
          if (item.id) {
            return {
              items: item.items,
              type: item.categoryId,
              orderNum: item.orderNum,
              id: item.id,
              productCode: this.productForm.productCode
            };
          } else {
            return {
              items: item.items,
              type: item.categoryId,
              orderNum: item.orderNum,
              productCode: this.productForm.productCode
            };
          }
        });
        const res = await this.$http({
          url: "/buz/productMaterial/add",
          type: "POST",
          data: {
            productCode: this.productForm.productCode,
            productId: this.productForm.id,
            materials: obj
          }
        })
        this.$Message.success("操作成功");
      }

      this.formArr.forEach;
    },
    changeItem(event, item) {
      item.name = event.target.value.trim()
    },
    addForm() {
      this.formArr.push({
        categoryId: "",
        orderNum: "",
        items: [
          {
            name: "",
            url: "",
            transUrl: ''
          }
        ]
      });
    },
    getAllTypeList() {
      productManageGetAllType(this.productForm.productCode, 1).then(res => {
        this.typeList = res.data;
      });
    },
    removeList(index, idx) {
      this.formArr[index].items.splice(idx, 1);
    },
    setTop(index, idx) {
      const current = this.formArr[index].items.splice(idx, 1)[0];
      this.formArr[index].items.unshift(current);
    },
    addPdfList(index) {
      this.formArr[index].items.push({
        name: "",
        url: "",
        transUrl: ''
      });
    },
    handleBeforeUpload(file, item, index, idx) {
      if (!/\.(pdf|xls|xlsx)$/.test(file.name.toLowerCase())) {
        this.$Message.error("上传格式不正确，请上传pdf,xls,xlsx格式文件");
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      uploadFile(formData).then(async res => {
        item.url = res.data[0].path;
        item.transUrl = await this.$units.transUrl(res.data[0].path);
        //上传完重新验证字段
        this.$refs["form" + index][0].validateField(`items.${idx}.url`);
      });
      return false;
    },
    resetForm() {
      this.type = "1";
      this.formArr = [];
      this.postArr = [];
    }
  },
  created() {
    this.resetForm();
    if (this.$route && (this.$route.meta || this.$route.meta.title != "首页")) {
      this.$nextTick(() => {
        const arr = this.$route.matched
          .filter(item => item.meta.title)
          .map(item => {
            if (item.meta.title != "首页") {
              return {
                name: item.meta.title,
                path: item.path
              };
            }
          })
          .filter(item => item);
        window.parent.postMessage({ nav: arr }, "*");
      });
    }
    this.initRule();
    this.getAllTypeList();
  }
};
</script>
<style lang="scss" scoped>
// /deep/.ivu-form-item-content{
//   height: 34px;
// }
/deep/ .ivu-col-span-6,.ivu-col-span-16,.ivu-col-span-4{
  max-width: 40%;
  flex: 0 0 40%;
}
.product-resourse-wrap {
  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ECECEC;
    }

    .ivu-tabs-ink-bar {
      display: none;
    }

    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515C6F;
    }

    .ivu-tabs-tab-active {
      position: relative;
      color: #236DFF;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236DFF;
      }
    }
  }

  .closeBtn {
    text-align: right;
    right: 40px;
    position: absolute;
    top: 20px;
    z-index: 100;

    &:hover {
      cursor: pointer;
    }
  }

  .upLoadBox {
    // margin-left: 30px;
    margin-bottom: 30px;

    /deep/ .wrapper {
      flex-direction: row !important;
    }
  }

  .btnTop {
    margin-left: 40px;
    margin-top: 30px;
  }

  .formBox {
    border: 1px solid #eee;
    margin: 40px;
    margin-top: 20px;
    position: relative;
  }

  /deep/ .ivu-form-item-content {
    height: 34px;

    >div {
      // float: left;
      // position: relative;
    }

    .ivu-form-item-error-tip {
      // float: none;
      // clear: both;
    }
  }

  /deep/ .ivu-tabs {
    padding-top: 10px !important;
  }

  /deep/ .btn {
    color: #236dff;
    float: left;
    margin-right: 20px;

    &:hover {
      cursor: pointer;
    }
  }

  .btnBox {
    text-align: center;
    padding: 20px 0;
  }
}
</style>
